/* SNODIS Set-Builder */
(function () {
  var root = document.querySelector('[data-sn-bundle]');
  if (!root) return;
  var data = JSON.parse(root.querySelector('[data-bundle-json]').textContent);
  var P = data.products;
  var tiers = data.tiers; // sorted desc by min
  var picked = [];        // slots in pick order: { key, pid } – the same product may be picked several times
  var choice = {};        // slot key -> { color, size }
  var MAX = data.max || 6;
  var seq = 0;
  var step = 1;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var money = function (c) { return (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };

  function tierFor(n) { for (var i = 0; i < tiers.length; i++) if (n >= tiers[i].min) return tiers[i]; return null; }
  function optIndex(p, names) {
    for (var i = 0; i < p.options.length; i++) if (names.indexOf(String(p.options[i]).toLowerCase()) > -1) return i;
    return -1;
  }
  function colorIdx(p) { return optIndex(p, ['farbe', 'color', 'colour']); }
  function sizeIdx(p) {
    var i = optIndex(p, ['größe', 'groesse', 'size', 'grösse']);
    if (i > -1) return i;
    var c = colorIdx(p);
    for (var k = 0; k < p.options.length; k++) if (k !== c) return k;
    return -1;
  }
  function values(p, idx) {
    var out = [];
    p.variants.forEach(function (v) { var val = v.options[idx]; if (out.indexOf(val) < 0) out.push(val); });
    return out;
  }
  function findVariant(slot) {
    var p = P[slot.pid], ch = choice[slot.key] || {}, ci = colorIdx(p), si = sizeIdx(p);
    return p.variants.find(function (v) {
      return (ci < 0 || v.options[ci] === ch.color) && (si < 0 || v.options[si] === ch.size);
    });
  }
  function basePrice(slot) {
    var v = findVariant(slot);
    if (v) return v.price;
    var p = P[slot.pid], ch = choice[slot.key] || {}, ci = colorIdx(p);
    var cand = p.variants.filter(function (x) { return x.available && (ci < 0 || !ch.color || x.options[ci] === ch.color); });
    return (cand[0] || p.variants[0]).price;
  }
  function totals() {
    var t = tierFor(picked.length), orig = 0, fin = 0;
    picked.forEach(function (slot) {
      var pr = basePrice(slot);
      orig += pr;
      fin += t ? Math.ceil(pr * (1 - t.pct / 100)) : pr;
    });
    return { tier: t, orig: orig, final: fin, save: orig - fin };
  }

  /* ---------- step 1 ---------- */
  function count(pid) { return picked.filter(function (x) { return x.pid === pid; }).length; }
  function addSlot(pid) {
    if (picked.length >= MAX) return;
    var p = P[pid], ci = colorIdx(p), si = sizeIdx(p), def = {};
    if (ci > -1) {
      var cols = values(p, ci), used = picked.filter(function (x) { return x.pid === pid; }).map(function (x) { return choice[x.key].color; });
      /* pre-select black first, then a colour not used yet in the set */
      def.color = cols.find(function (c) { return /schwarz|black/i.test(c) && used.indexOf(c) < 0; }) || cols.find(function (c) { return used.indexOf(c) < 0; }) || cols[0];
    }
    if (si > -1 && values(p, si).length === 1) def.size = values(p, si)[0];
    var key = pid + '#' + (++seq);
    choice[key] = def;
    picked.push({ key: key, pid: pid });
  }
  function removeSlot(pid) {
    for (var i = picked.length - 1; i > -1; i--) if (picked[i].pid === pid) { delete choice[picked[i].key]; picked.splice(i, 1); return; }
  }
  function paintCards() {
    $$('[data-pick]').forEach(function (btn) {
      var pid = btn.getAttribute('data-pick'), n = count(pid);
      btn.setAttribute('aria-pressed', n > 0);
      btn.classList.toggle('is-picked', n > 0);
      var q = root.querySelector('[data-qty-for="' + pid + '"]');
      if (q) {
        q.querySelector('[data-qty]').textContent = n;
        q.querySelector('[data-dec]').disabled = n === 0;
        q.querySelector('[data-inc]').disabled = picked.length >= MAX;
      }
    });
  }
  $$('[data-pick]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pid = btn.getAttribute('data-pick');
      /* cards with a quantity stepper add one more; plain cards toggle */
      if (root.querySelector('[data-qty-for="' + pid + '"]')) addSlot(pid);
      else if (count(pid)) removeSlot(pid); else addSlot(pid);
      paintCards(); updateBar();
    });
  });
  $$('[data-qty-for]').forEach(function (q) {
    var pid = q.getAttribute('data-qty-for');
    q.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t) return;
      if (t.hasAttribute('data-inc')) addSlot(pid);
      if (t.hasAttribute('data-dec')) removeSlot(pid);
      paintCards(); updateBar();
    });
  });

  /* ---------- step 2 ---------- */
  var MATRIX = {
    'unter 155 cm': ['XS', 'XS', 'S', 'M', 'M', 'L', 'XL'],
    '155–160 cm': ['XS', 'S', 'S', 'M', 'L', 'L', 'XL'],
    '161–165 cm': ['S', 'S', 'M', 'M', 'L', 'XL', '2XL'],
    '166–170 cm': ['S', 'M', 'M', 'L', 'XL', 'XL', '2XL'],
    '171–175 cm': ['M', 'M', 'L', 'L', 'XL', '2XL', '3XL'],
    'über 175 cm': ['M', 'L', 'L', 'XL', '2XL', '2XL', '3XL']
  };
  var WEIGHTS = ['unter 50 kg', '50–60 kg', '61–70 kg', '71–80 kg', '81–90 kg', '91–100 kg', 'über 100 kg'];
  var ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL'];
  var norm = function (s) { var n = String(s).replace(/\s+/g, '').toUpperCase(); return { XXL: '2XL', XXXL: '3XL', XXXXL: '4XL' }[n] || n; };

  function renderSizes() {
    var wrap = $('[data-sizes]');
    wrap.innerHTML = '';
    picked.forEach(function (slot, idx) {
      var id = slot.key, p = P[slot.pid], ci = colorIdx(p), si = sizeIdx(p), ch = choice[id];
      var nth = picked.filter(function (x) { return x.pid === slot.pid; }).length > 1 ? ' <span class="sn-bundle__nth">Teil ' + (idx + 1) + '</span>' : '';
      var el = document.createElement('div');
      el.className = 'sn-bundle__item';
      var html = '<div class="sn-bundle__item-head"><img src="' + p.image + '" alt="" width="64" height="80" loading="lazy">' +
        '<div><a href="' + p.url + '" target="_blank" rel="noopener" class="sn-bundle__item-title">' + esc(p.title) + '</a>' + nth +
        '<span class="sn-bundle__item-price" data-price></span></div></div>';
      if (ci > -1 && values(p, ci).length > 1) {
        html += '<p class="sn-bundle__label">' + esc(p.options[ci]) + '</p><div class="sn-bundle__opts" data-kind="color">' +
          values(p, ci).map(function (c) { return '<button type="button" class="sn-bundle__opt" data-val="' + esc(c) + '"' + (c === ch.color ? ' aria-pressed="true"' : ' aria-pressed="false"') + '>' + esc(c) + '</button>'; }).join('') + '</div>';
      }
      if (si > -1) {
        html += '<p class="sn-bundle__label">' + esc(p.options[si]) + ' <button type="button" class="sn-bundle__helper-toggle" aria-expanded="false">Größe unsicher?</button></p>' +
          '<div class="sn-bundle__helper" hidden>' +
          '<p class="sn-bundle__label">Körpergröße</p><div class="sn-bundle__opts" data-kind="h">' + Object.keys(MATRIX).map(function (h) { return '<button type="button" class="sn-bundle__opt sn-bundle__opt--sm" data-val="' + h + '" aria-pressed="false">' + h + '</button>'; }).join('') + '</div>' +
          '<p class="sn-bundle__label">Gewicht</p><div class="sn-bundle__opts" data-kind="w">' + WEIGHTS.map(function (w, i) { return '<button type="button" class="sn-bundle__opt sn-bundle__opt--sm" data-val="' + i + '" aria-pressed="false">' + w + '</button>'; }).join('') + '</div>' +
          '<p class="sn-bundle__rec" data-rec hidden></p></div>' +
          '<div class="sn-bundle__opts" data-kind="size"></div>';
      }
      el.innerHTML = html;
      wrap.appendChild(el);
      var helper = { h: null, w: null };

      function paintSizes() {
        var box = el.querySelector('[data-kind="size"]');
        if (!box) return;
        box.innerHTML = values(p, si).map(function (s) {
          var v = p.variants.find(function (x) { return x.options[si] === s && (ci < 0 || x.options[ci] === choice[id].color); });
          var ok = v && v.available;
          if (!ok && choice[id].size === s) choice[id].size = null;
          return '<button type="button" class="sn-bundle__opt" data-val="' + esc(s) + '" aria-pressed="' + (choice[id].size === s) + '"' + (ok ? '' : ' disabled') + '>' + esc(s) + '</button>';
        }).join('');
      }
      function paintPrice() {
        var v = findVariant(slot);
        el.querySelector('[data-price]').textContent = money(v ? v.price : basePrice(slot));
      }
      paintSizes(); paintPrice();

      el.addEventListener('click', function (e) {
        var t = e.target.closest('button');
        if (!t) return;
        if (t.classList.contains('sn-bundle__helper-toggle')) {
          var hb = el.querySelector('.sn-bundle__helper');
          hb.hidden = !hb.hidden;
          t.setAttribute('aria-expanded', !hb.hidden);
          return;
        }
        var group = t.parentElement.getAttribute('data-kind');
        if (!group || t.disabled) return;
        $$('button', t.parentElement).forEach(function (b) { b.setAttribute('aria-pressed', b === t); });
        var val = t.getAttribute('data-val');
        if (group === 'color') { choice[id].color = val; paintSizes(); }
        if (group === 'size') choice[id].size = val;
        if (group === 'h') helper.h = val;
        if (group === 'w') helper.w = +val;
        if ((group === 'h' || group === 'w') && helper.h && helper.w !== null) {
          var rec = MATRIX[helper.h][helper.w];
          var avail = values(p, si);
          var hit = avail.find(function (s) { return norm(s) === rec; }) ||
            avail.slice().sort(function (a, b) { return ORDER.indexOf(norm(a)) - ORDER.indexOf(norm(b)); })
              .find(function (s) { return ORDER.indexOf(norm(s)) >= ORDER.indexOf(rec); }) || avail[avail.length - 1];
          choice[id].size = hit;
          var r = el.querySelector('[data-rec]');
          r.hidden = false;
          r.innerHTML = 'Unsere Empfehlung: <strong>' + esc(hit) + '</strong>';
          paintSizes();
        }
        paintPrice();
        updateBar();
      });
    });
  }

  /* ---------- step 3 ---------- */
  function renderSummary() {
    var ul = $('[data-summary]');
    ul.innerHTML = picked.map(function (slot) {
      var p = P[slot.pid], v = findVariant(slot), ch = choice[slot.key];
      var meta = [ch.color, ch.size].filter(Boolean).join(' · ');
      return '<li><img src="' + p.image + '" alt="" width="56" height="70" loading="lazy"><div><strong>' + esc(p.title) + '</strong><span>' + esc(meta) + '</span></div><span>' + money(v.price) + '</span></li>';
    }).join('');
    var t = totals();
    $('[data-t-orig]').textContent = money(t.orig);
    $('[data-t-label]').textContent = 'Set-Rabatt (−' + t.tier.pct + ' %)';
    $('[data-t-save]').textContent = '−' + money(t.save);
    $('[data-t-final]').textContent = money(t.final);
  }

  /* ---------- navigation ---------- */
  function ready() {
    if (step === 1) return picked.length >= 2;
    if (step === 2) return picked.every(function (slot) { var v = findVariant(slot); return v && v.available; });
    return true;
  }
  function updateBar() {
    var n = picked.length, t = totals();
    $('[data-count]').textContent = n === 0 ? 'Wähle mindestens 2 Teile' : n + (n === 1 ? ' Teil gewählt – noch 1 für den Set-Rabatt' : ' Teile gewählt');
    $('[data-savings]').textContent = t.tier ? '−' + t.tier.pct + ' % · du sparst ' + money(t.save) : '';
    var next = $('[data-next]');
    next.disabled = !ready();
    next.textContent = step === 1 ? 'Größen wählen' : step === 2 ? 'Zur Übersicht' : 'Set kaufen · ' + money(t.final);
    $('[data-back]').hidden = step === 1;
  }
  function go(n) {
    step = n;
    $$('[data-panel]').forEach(function (el) { el.hidden = +el.getAttribute('data-panel') !== n; });
    $$('[data-step-dot]').forEach(function (el) {
      var s = +el.getAttribute('data-step-dot');
      el.classList.toggle('is-active', s === n);
      el.classList.toggle('is-done', s < n);
    });
    if (n === 2) renderSizes();
    if (n === 3) renderSummary();
    updateBar();
    $('.sn-bundle__steps').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  $('[data-back]').addEventListener('click', function () { go(step - 1); });
  $('[data-next]').addEventListener('click', function () {
    if (!ready()) return;
    if (step < 3) return go(step + 1);
    checkout();
  });

  function checkout() {
    var btn = $('[data-next]'), err = $('[data-bundle-error]');
    btn.disabled = true;
    btn.textContent = 'Set wird vorbereitet …';
    err.hidden = true;
    var items = picked.map(function (slot) { return { id: findVariant(slot).id, quantity: 1 }; });
    var code = totals().tier.code;
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Fehler'); });
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout';
    }).catch(function (e) {
      err.textContent = 'Das Set konnte nicht in den Warenkorb gelegt werden: ' + e.message;
      err.hidden = false;
      updateBar();
    });
  }

  paintCards();
  updateBar();
})();
